module.exports = __webpack_public_path__ + "static/media/details_close.a6c02241.png";